'use client';

import useSWRImmutable from 'swr/immutable';
import {useDebounce} from './common.hooks';
import {useState} from 'react';

export const useSWRDispatch = <TData>(apiCallback: (...args) => Promise<TData>) => {
	const [key, setKey] = useState<string | null>(null);

	const {
		data,
		isLoading,
		error: _error,
		mutate
	} = useSWRImmutable(key || null, ([_]) => apiCallback(), {
		shouldRetryOnError: false,
		revalidateOnFocus: false,
		populateCache: (result: TData, err: unknown) => (err ? undefined : result)
	});

	const clearCache = (): void => {
		mutate(undefined, false).catch((err) => console.error(err));
	};

	const dispatch = useDebounce(async (newKey: string) => {
		setKey(newKey);
		await mutate();
	});

	let error: string | undefined;
	if (data?.['error']) {
		error = data['error'] || (_error as string);
	}

	return {
		data,
		isLoading,
		error,
		clearCache,
		dispatch
	};
};
